import { Badge, Input } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const TableHeader = styled.div`
  align-items: center;
  background: var(--color-bg-weaker);
  border-bottom: 1px solid var(--color-border-default);
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
  min-height: 48px;
  padding: 0 16px;

  ${DEVICE.mobile.max} {
    flex-direction: column;
    gap: 8px;
    height: auto;
    padding: 8px;
  }
`;

const TableHeaderInput = styled.div`
  margin-left: auto;
  width: 240px;

  ${Input.S.Input} {
    &::placeholder {
      color: var(--color-color-components-input-fg-default);
    }
  }
`;

const SubtitleWrapper = styled.div`
  align-items: center;
  background-color: var(--color-bg-weaker);
  border-bottom: 1px solid var(--color-border-default);
  display: flex;
  flex-direction: row;
  gap: 8px;
  height: 48px;
  padding: 0 16px;

  ${Badge.S.Badge} {
    &:hover {
      background-color: var(--color-bg-default);
    }
  }
`;

export { SubtitleWrapper, TableHeader, TableHeaderInput };
